import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DateAdapter, MdSnackBar} from '@angular/material';
import {AgrisEstadosIds, AgrisService, PermisosService} from '../../../services';
import * as moment from 'moment';
import {
  CotizacionAgrisViewModel,
  FormasDePagoViewModel,
  InsumoCotizacionViewModel,
  InsumoViewModel,
  ModalidadFacturacionViewModel, OficinaComercialViewModel, SucursalComercialViewModel
} from '../common/AgrisViewModels';
import {Subscription} from 'rxjs/Subscription';
import {CuentaAutocompleteComponent} from '../../common';
import {Router} from '@angular/router';
import {PATH_AGRIS_COTIZACION_DETALLE} from '../../../navigation/navigation.module';

@Component({
  selector: 'app-agris-nueva-cotizacion-page',
  templateUrl: './agris-nueva-cotizacion-page.component.html',
  styleUrls: ['./agris-nueva-cotizacion-page.component.scss', '../common/agris-common-styles.scss']
})
export class AgrisNuevaCotizacionPageComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(CuentaAutocompleteComponent) cuentaAutocomplete: CuentaAutocompleteComponent;

  subsctiptions: Subscription[] = [];

  acordeonListOpenIndex = 0;

  formaPagoSelected = '0';
  formasDePago: FormasDePagoViewModel[] = [];

  facturacionSelected = '0'
  metodosDeFacturacion: ModalidadFacturacionViewModel[] = [];


  // vista, true es desktop, false es mobil
  viewDesktop = true;
  openSideNav = false;

  insumo: InsumoViewModel = null;

  // por defecto en 15 dias
  vigencia = moment().add(15, 'days').toDate();
  vigenciaMin = moment().add(1, 'days').toDate();
  vigenciaMax = moment().add(30, 'days').toDate();

  oficina: OficinaComercialViewModel = null;
  sucursal: SucursalComercialViewModel = null;

  titulo = 'Nueva Cotización';

  isEstadoGuardada = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.viewDesktop = event.target.innerWidth > 890
  }

  constructor(
    private dateAdapter: DateAdapter<Date>,
    public agrisService: AgrisService,
    private snackBar: MdSnackBar,
    private router: Router,
    private permServ: PermisosService,
  ) {
    permServ.verificarAccesoDeURL();
    this.dateAdapter.setLocale('en-GB');
    this.viewDesktop = window.innerWidth > 890;
    this.insumo = this.agrisService.nuevaCotizInsumo;
    this.agrisService.nuevaCotizInsumo = null;
    agrisService.initializeOficinaSucursal();

    this.subsctiptions.push(
      agrisService.getFormasPago().subscribe(x => {
        if (x && x.length) {
          this.formasDePago = (x as FormasDePagoViewModel[]);
          // evitamos sobreescribir la seleccion durante la edicion
          if (agrisService.editarCotizacion === null) {
            this.formaPagoSelected = this.formasDePago[0].Nombre
          }
        }
      }, err => this.agrisService.showSnackbarAPIError())
    );
    this.subsctiptions.push(
      agrisService.getModalidadFacturacion().subscribe(x => {
        if (x && x.length) {
          this.metodosDeFacturacion = (x as ModalidadFacturacionViewModel[]);
          // evitamos sobreescribir la seleccion durante la edicion
          if (agrisService.editarCotizacion === null) {
            this.facturacionSelected = this.metodosDeFacturacion[0].Nombre;
          }
        }
      }, err => this.agrisService.showSnackbarAPIError())
    );

    this.subsctiptions.push(
      agrisService.oficina$.subscribe(x => {
        this.oficina = x;
      })
    );

    this.subsctiptions.push(
      agrisService.sucursal$.subscribe(x => {
        this.sucursal = x;
      })
    );

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // verificamos si estamos editando una cotizacion
    if (this.agrisService.editarCotizacion !== null) {
      this.cuentaAutocomplete.selectedCuentas.push(this.agrisService.editarCotizacion.Cliente);
      this.formaPagoSelected = this.agrisService.editarCotizacion.FormaDePago;
      this.facturacionSelected = this.agrisService.editarCotizacion.MetodoFacturacion;
      this.vigencia = moment.unix(this.agrisService.editarCotizacion.Vigencia).toDate();
      this.vigenciaMin = moment.unix(this.agrisService.editarCotizacion.FechaCreacion).add(1, 'days').toDate();
      this.vigenciaMax = moment.unix(this.agrisService.editarCotizacion.FechaCreacion).add(30, 'days').toDate();
      this.titulo = 'Editando cotización N.º ' + this.agrisService.editarCotizacion.NumeroCotizacion;
    }
  }

  ngOnDestroy() {
    this.subsctiptions.forEach(x => x.unsubscribe());
    this.agrisService.editarCotizacion = null;
  }

  convertInsumo(): InsumoCotizacionViewModel[] {
    return [{
      Cantidad: this.agrisService.cantidadInsumo,
      CodigoInsumo: this.insumo.Nombre,
      Cot_ID: 0,
      Detalle_ID: 0,
      Flete: 0,
      Margen: 0,
      MargenPorcentaje: this.insumo.Margen,
      Nombre: this.insumo.Descripcion,
      PrecioLista: this.insumo.PrecioPublico,
      PrecioMinimo: this.insumo.PrecioMinimo,
      Proveedor: this.insumo.DescripcionProveedor,
      Variacion: 0,
      TrmRN2: this.insumo.TrmRN2,
      UnidadMedida: this.insumo.UnidadMedida,
      Multiplo: this.insumo.Multiplo,
      PrecioVenta: this.insumo.PrecioPublico,
      PrecioListaID: this.insumo.PrecioListaID,
    }];
  }

  nextOrSave() {
    if (this.acordeonListOpenIndex < 2) {
      this.acordeonListOpenIndex++;
    } else {
      if (!this.cuentaAutocomplete.selectedCuentas.length) {
        this.acordeonListOpenIndex = 0;
        this.snackBar.open('Por favor, complete todos los campos.', null, {duration: 3000})
        return;
      }
      // editar
      if (this.agrisService.editarCotizacion !== null) {
        const payload: CotizacionAgrisViewModel = {...this.agrisService.editarCotizacion};
        payload.MetodoFacturacion = this.facturacionSelected;
        payload.FormaDePago = this.formaPagoSelected;
        payload.IdCliente = this.cuentaAutocomplete.selectedCuentas[0].Id;
        payload.Vigencia = moment(this.vigencia).unix();
        payload.FormaDePagoID = this.formasDePago.find(x => x.Nombre === this.formaPagoSelected).ID;
        payload.MetodoFacturacionID = this.metodosDeFacturacion.find(x => x.Nombre === this.facturacionSelected).ID;
        this.agrisService.editarDatosCotizacion(payload).subscribe(x => {
          if (x && x.NumeroCotizacion) {
            this.addHomeStateToHistory();
            this.router.navigate([PATH_AGRIS_COTIZACION_DETALLE, x.NumeroCotizacion])
          } else {
            this.agrisService.showSnackbarAPIError();
          }
        }, err => {
          this.agrisService.showSnackbarAPIError();
        });
      } else {
        // crear
        const margenTotal = this.insumo === null ? 0 :
          Number(((this.insumo.PrecioPublico - this.insumo.TrmRN2) * this.agrisService.cantidadInsumo).toFixed(2));
        const facturacionTotal = this.insumo === null ? 0 :
          Number((this.insumo.PrecioPublico * this.agrisService.cantidadInsumo).toFixed(2));
        const nuevaCotiz: CotizacionAgrisViewModel = {
          Cliente: undefined,
          EstadosCotizacion: [],
          FacturacionTotal: facturacionTotal,
          MargenTotal: margenTotal,
          FormaDePago: this.formaPagoSelected,
          IdCliente: this.cuentaAutocomplete.selectedCuentas[0].Id,
          InsumosCotizacion: this.insumo !== null ? this.convertInsumo() : [],
          Mail: false,
          MensajeError: '',
          MetodoFacturacion: this.facturacionSelected,
          NumeroCotizacion: 0,
          Observacion: '',
          PDF: false,
          Porcentaje: this.insumo === null ? 0 : Number((margenTotal / facturacionTotal).toFixed(2)),
          Vigencia: moment(this.vigencia).unix(),
          IdSucursal: this.sucursal.Id,
          Sucursal: this.sucursal.Nombre,
          IdOficina: this.oficina.Id,
          Oficina: this.oficina.Nombre,
          CantidadCotizaciones: 0,
          CantidadPaginas: 0,
          FechaCreacion: 0,
          UsuarioCreador: null,
          Contacto: null,
          FormaDePagoID: this.formasDePago.find(x => x.Nombre === this.formaPagoSelected).ID,
          MetodoFacturacionID: this.metodosDeFacturacion.find(x => x.Nombre === this.facturacionSelected).ID,
          Fue_ID: 1 // fuente de las cotizaciones, 1 es web
        }
        this.agrisService.saveNuevaCotizacion(nuevaCotiz).subscribe(x => {
          if (x) {
            this.agrisService.cotizacionCreada = true;
            this.addHomeStateToHistory();
            this.router.navigate([PATH_AGRIS_COTIZACION_DETALLE, x.NumeroCotizacion])
          } else {
            this.agrisService.showSnackbarAPIError();
          }
        }, err => {
          this.agrisService.showSnackbarAPIError();
        });
      }
    }
  }

  addHomeStateToHistory() {
    // vamos a añadir un estado nuevo al backbutton para que vuelva a la home de agris
    // desde el detalle de la cotizacion
    history.pushState(null, null, '/agris');
  }

  vigenciaDisabled() {
    if (this.agrisService.editarCotizacion !== null) {
      return (this.agrisService.editarCotizacion.EstadosCotizacion[0].CotizacionAgrisEstadoID === AgrisEstadosIds.GUARDADA) || this.agrisService.forceEdit;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-nueva-cotizacion-page/agris-nueva-cotizacion-page.component.ts